import { createExcelBroadcastUpdate } from '@module/helpers/centrifuge/messageUpdates';
import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import {
  type ExcelBroadcastMessage,
  isExcelBroadcastMessage,
} from '@module/types/centrifuge/public-message/excelMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class ExcelBroadcastHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<ExcelBroadcastMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isExcelBroadcastMessage(payload);
  }

  handle(payload: ExcelBroadcastMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;
    if (!context.playInfo) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setPlayInfo(createExcelBroadcastUpdate(payload, context.playInfo));
  }
}
